import { connect } from 'react-redux'
import { KingdomComponent } from './KingdomComponent'
import type { RootState } from 'shared/store/reducers'
import { featureCodes } from 'shared/utils'

const mapStateToProps = (state: RootState) => {
    const {
        kingdomDashboardPageState,
        kingdomCardPageState,
        kingdomBlazonsPageState,
        kingdomPrivilegesPageState,
        kingdomProfilePageState,
        featuresState
    } = state

    const error =
        kingdomDashboardPageState.dashboardError ||
        kingdomCardPageState.cardError ||
        kingdomBlazonsPageState.blazonsError ||
        kingdomPrivilegesPageState.privilegesError ||
        kingdomProfilePageState.profileError

    const networkError =
        kingdomDashboardPageState.dashboardNetworkError ||
        kingdomCardPageState.cardNetworkError ||
        kingdomBlazonsPageState.blazonsNetworkError ||
        kingdomPrivilegesPageState.privilegesNetworkError ||
        kingdomProfilePageState.profileNetworkError

    const availableFeatures = featuresState.available
    const isActiveZendesk = availableFeatures.includes(
        featureCodes.ACTIVATION_ZENDESK_REDIRECTION
    )

    return {
        error,
        networkError,
        availableFeatures,
        isActiveZendesk
    }
}

const Kingdom = connect(mapStateToProps, null)(KingdomComponent)

export { Kingdom }
